/** Parse comma-separated string into trimmed non-empty array */
export function parseCommaList(str: string): string[] {
  return str
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

/** Extract error message from failed fetch response */
export async function parseFetchError(response: Response): Promise<string> {
  const errorData = await response.json().catch(() => ({}));
  return (
    (errorData as { message?: string; error?: string }).message ||
    (errorData as { message?: string; error?: string }).error ||
    `HTTP error! status: ${response.status}`
  );
}
